import { useContext, useEffect } from "react";
import { unlink } from "./Api";
import { MessagesContext } from "../Context/MessagesContext";

function EstablishedContacts({
	contacts,
	updateContacts,
	activeContact,
	setActiveContact,
	inputRef,
	setAlertWindowOpen,
}) {
	const { messages } = useContext(MessagesContext);
	const deleteContact = (id) => unlink(id).finally(() => updateContacts());
	const addLastContactMessageInfo = (contact) => {
		const id = contact.contact_id;
		let arr = [...messages];
		arr.sort((a, b) => (a.datetime > b.datetime ? -1 : 1));
		const lastMessage = arr.find((i) => i.contact_id === id);
		// console.log(lastMessage);
		return { ...contact, lastMessage: lastMessage };
	};
	const getUnreadMessageCount = (contact) => {
		const id = contact.contact_id;
		let arr = [...messages];
		const contactMessages = arr.filter((i) => i.contact_id === id);
		const count = contactMessages.reduce(
			(accum, currentValue) =>
				currentValue.datetime_read === 0 && currentValue.direction === 0
					? accum + 1
					: accum,
			0
		);
		return count === 0 ? null : (
			<span className='unreader-messages-count'>{count}</span>
		);
	};
	useEffect(() => {
		let intervalId = setInterval(() => {
			updateContacts();
		}, 3000);
		return () => {
			clearInterval(intervalId);
		};
	}, []);
	return (
		<div className='contact-established'>
			{activeContact ? (
				<>
					<button
						className='back-button'
						onClick={() => {
							if (inputRef.current?.value) {
								setAlertWindowOpen(true);
								return;
							}
							setActiveContact(null);
						}}
					>{`⟵ К контактам`}</button>
					<div
						className={`contact ${
							activeContact ===
							contacts.find((contact) => contact.contact_id === activeContact)
								?.contact_id
								? "contact-active"
								: ""
						}`}
						onClick={() =>
							setActiveContact(
								contacts.find((contact) => contact.contact_id === activeContact)
									?.contact_id
							)
						}
					>
						{`${
							contacts.find((contact) => contact.contact_id === activeContact)
								?.alias
						}`}
						{getUnreadMessageCount(
							contacts.find((contact) => contact.contact_id === activeContact)
						)}
					</div>
				</>
			) : (
				contacts
					.map((contact) => addLastContactMessageInfo(contact))
					.sort((a, b) =>
						a.lastMessage?.datetime > b.lastMessage?.datetime ? -1 : 1
					)
					.map((contact, i) => (
						<div
							key={i}
							className={`contact ${
								activeContact === contact.contact_id ? "contact-active" : ""
							}`}
							onClick={() => setActiveContact(contact.contact_id)}
						>
							{`${contact.alias}`}
							{getUnreadMessageCount(contact)}

							{/* <button
						className='contact-action'
						onClick={(e) => {
							e.stopPropagation();
							deleteContact(contact.contact_id);
						}}
					>
						Закрыть контакт
					</button> */}
						</div>
					))
			)}
		</div>
	);
}

export default EstablishedContacts;
